export default {
  state: {
    step: 1,
    loading: false,
    error: null,
    isOnline: true,
    appReady: false,
    satisfactionSurveyConstants: {},
    devUsers: [],
    globalConstants: null,
    pendingCampaignOnboardingDialogShown: false,
    activeCampaign: null
  },
  mutations: {
    setLoading (state, payload) {
      state.loading = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    clearError (state) {
      state.error = null
    },
    setIsOnline (state, payload) {
      state.isOnline = payload
    },
    setAppReady (state, payload) {
      state.appReady = payload
    },
    setSatisfactionSurveyConstants (state, value) {
      state.satisfactionSurveyConstants = value
    },
    setDevUsers (state, value) {
      state.devUsers = value
    },
    setGlobalConstants (state, value) {
      state.globalConstants = value
    },
    setPendingCampaignOnboardingDialogShown (state, value) {
      state.pendingCampaignOnboardingDialogShown = value
    },
    setActiveCampaign (state, campaignId) {
      state.activeCampaign = campaignId
    }
  },
  actions: {
    clearError ({commit}) {
      commit('clearError')
    },
    setError ({commit}, payload) {
      commit('setError', payload)
    },
    setIsOnline ({commit}, payload) {
      commit('setIsOnline', payload)
    }
  },
  getters: {
    loading (state) {
      return state.loading
    },
    error (state) {
      return state.error
    },
    step (state) {
      return state.step
    },
    isOnline (state) {
      return state.isOnline
    },
    appReady (state) {
      return state.appReady
    },
    satisfactionSurveyConstants (state) {
      return state.satisfactionSurveyConstants
    },
    devUsers (state) {
      return state.devUsers
    },
    globalConstants (state) {
      return state.globalConstants
    },
    pendingCampaignOnboardingDialogShown (state) {
      return state.pendingCampaignOnboardingDialogShown
    },
    activeCampaign (state) {
      return state.activeCampaign
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/shared/index.js